import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9axhqqxgf7: FaireBrandEntity = {
  token: "b_9axhqqxgf7",
  type: "brand",
  name: "Heynemo",
  avatarUrl:
    "https://cdn.faire.com/fastly/844b494d26093dbdd039ee428a16779685c4a064fbce4a17fb6e0173604b2904.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/210bfe74bc00ae99b641fcc53fe7d2be561b5e9c634bfae5c7bc24975d911a01.png",
  logoUrl:
    "https://cdn.faire.com/fastly/844b494d26093dbdd039ee428a16779685c4a064fbce4a17fb6e0173604b2904.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/210bfe74bc00ae99b641fcc53fe7d2be561b5e9c634bfae5c7bc24975d911a01.png",
  location: "Lawenceville, GA, USA",
  minimumOrderDollars: 100,
  rating: 4.3,
  reviewCount: 80,
  isInsider: true,
  description:
    "At Heynemo, we believe your furniture should tell your story—a sanctuary that reflects who you are. Inspired by the spirit of Nemo, our designs embody bravery, optimism, and the warmth of home.\n\nLike Nemo, we navigate challenges with resilience, crafting furniture that stands the test of time. Each piece is made to inspire serenity, joy, and everyday confidence. Built with quality materials and thoughtful craftsmanship, our collections offer not just beauty, but comfort and peace of mind.\n\nWe are committed to a sustainable and ethical approach—using eco-friendly materials, supporting local artisans, and leaving a positive footprint on the world.\n\nEmbrace the Nemo spirit with Heynemo. Let our furniture inspire a life of courage, comfort, and cozy moments. Together, we can create spaces that reflect your journey and celebrate limitless possibilities.\n\nDive into Heynemo—where courage meets comfort, and every piece tells a tale of optimism and home.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:10.214Z",
    importedBy: "entity-db-cli",
  },
};
